<portal-page-heading>{{ 'portal.systemInfo.title' | portalTranslate }}</portal-page-heading>

<portal-loading-indicator-container [loading]="loading$ | async">
  <portal-errors [errors]="error$ | async"></portal-errors>

  @if (viewModel$ | async; as viewModel) {
    <div class="system-info">
      <portal-card>
        <h2 header>{{ 'portal.systemInfo.versions' | portalTranslate }}</h2>
        <dl>
          <dt>{{ 'portal.systemInfo.C5ProvisioningBuildDate' | portalTranslate }}</dt>
          <dd>{{ viewModel.info.buildInfo.C5ProvisioningBuildDate }}</dd>
          <dt>{{ 'portal.systemInfo.C5ProvisioningVersion' | portalTranslate }}</dt>
          <dd>{{ viewModel.info.buildInfo.C5ProvisioningVersion }}</dd>
          <dt>{{ 'portal.systemInfo.portalBackendBuildDate' | portalTranslate }}</dt>
          <dd>{{ viewModel.info.buildInfo.portalBackendBuildDate }}</dd>
          <dt>{{ 'portal.systemInfo.portalBackendVersion' | portalTranslate }}</dt>
          <dd>{{ viewModel.info.buildInfo.portalBackendVersion }}</dd>
          <dt>{{ 'portal.systemInfo.portalFrontendVersion' | portalTranslate }}</dt>
          <dd>{{ viewModel.version.version }}</dd>
        </dl>
      </portal-card>
      <portal-card>
        <h2 header>{{ 'portal.systemInfo.branding' | portalTranslate }}</h2>
        <dl>
          <dt>{{ 'portal.systemInfo.branding.themeName' | portalTranslate }}</dt>
          <dd>{{ viewModel.branding.themeName }}</dd>
          <dt>{{ 'portal.systemInfo.branding.pageTitle' | portalTranslate }}</dt>
          <dd>{{ viewModel.branding.pageTitle }}</dd>
          @if (viewModel.branding.pageSubtitle | notBlank) {
            <dt>{{ 'portal.systemInfo.branding.pageSubtitle' | portalTranslate }}</dt>
            <dd>{{ viewModel.branding.pageSubtitle }}</dd>
          }
          @if (viewModel.info.themeNames.length > 0) {
            <dt>{{ 'portal.systemInfo.branding.availableBrandings' | portalTranslate }}</dt>
            <dd>
              <ul>
                @for (name of viewModel.info.themeNames; track name) {
                  <li>{{ name }}</li>
                }
              </ul>
            </dd>
          }
        </dl>
      </portal-card>
      <portal-card>
        <h2 header>{{ 'portal.systemInfo.backendSystems' | portalTranslate }}</h2>
        @if (viewModel.backendSystems.systems.length > 0) {
          <ul>
            @for (system of viewModel.backendSystems.systems; track system) {
              <li [ngClass]="{ active: system === viewModel.currentBackendSystem }">
                {{ system }}
              </li>
            }
          </ul>
        }
        @if (viewModel.backendSystems.systems.length === 0) {
          <div>
            {{ 'portal.systemInfo.backendSystems.none' | portalTranslate }}
          </div>
        }
      </portal-card>
      <portal-card>
        <h2 header>{{ 'portal.systemInfo.config' | portalTranslate }}</h2>
        <dl>
          @for (item of viewModel.info.config | keyvalue; track item) {
            <dt>{{ item.key }}</dt>
            <dd>{{ item.value }}</dd>
          }
        </dl>
      </portal-card>
      <portal-card>
        <h2 header>{{ 'portal.systemInfo.systemConfig' | portalTranslate }}</h2>
        <dl>
          @for (item of viewModel.info.systemConfig | keyvalue; track item) {
            <dt>{{ item.key }}</dt>
            <dd>{{ item.value }}</dd>
          }
        </dl>
      </portal-card>
    </div>
  }
</portal-loading-indicator-container>
